import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cartMinusDisabled",
  "use": "icon-cartMinusDisabled-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cartMinusDisabled\">\n<rect width=\"32\" height=\"32\" rx=\"4\" fill=\"#E5E5E5\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7 16C7 15.4477 7.44772 15 8 15H24C24.5523 15 25 15.4477 25 16C25 16.5523 24.5523 17 24 17H8C7.44772 17 7 16.5523 7 16Z\" fill=\"#969696\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol